import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { AssessmentTraitManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/assessment-traits")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <AssessmentTraitManagement />
    </RouteGuard>
  ),
});
